module.exports = __webpack_public_path__ + "img/SketchPngac97280f241a820a684f88e3d1c7c959ce837fbd47d3b4cf2c2bd7ea308cc855.1a7beba8.png";